
import { QrCode, AlertCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

interface PublicMenuErrorProps {
  error: string;
  tableId: string | null;
}

export function PublicMenuError({ error, tableId }: PublicMenuErrorProps) {
  const { t } = useTranslation();
  
  // Function to handle refresh
  const handleRefresh = () => {
    window.location.reload();
  };
  
  // Function to go to homepage
  const goToHomepage = () => {
    window.location.href = '/';
  };
  
  return (
    <div className='container mx-auto py-8 text-center'>
      <div className='max-w-md mx-auto p-6 bg-white dark:bg-gray-800 rounded-lg shadow-lg'>
        <AlertCircle className='h-16 w-16 mx-auto mb-4 text-red-500 opacity-70' />
        <h1 className='text-3xl font-bold mb-4'>{t('menuError')}</h1>
        <p className='text-muted-foreground mb-6'>{error}</p>
        <p className='text-sm mb-4'>
          {tableId ? `Table ID: ${tableId}` : t('noTableIdProvided')}
        </p>
        
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button onClick={handleRefresh} variant="outline">
            {t('tryAgain')}
          </Button>
          <Button onClick={goToHomepage}>
            {t('goToHomepage')}
          </Button>
        </div>
      </div>
    </div>
  );
}
